module.exports = __webpack_public_path__ + "img/Scrum.bb67add6.webp";